<template>
  <div class="crevent-coupon-detail">
    <div v-if="loading" class="crevent-state">資料載入中...</div>
    <div v-if="item" class="couponMain">
      <div class="container">
        <div class="main">
          <div class="product_box">
            <div class="img_box">
              <div class="tag">限量兌換</div>
              <img :src="itemImage" :alt="item.Name + '圖片'">
            </div>
            <div class="text_box">
              <div class="text">
                <div class="kilogramTotal">目前可用減碳量：<img src="img/leaf_w.svg" alt="">{{ formatCarbon(item.CarbonValueAvailable) }} kg CO₂e</div>
                <h2>{{ item.Name }}</h2>
                <p>所需減碳量：<img src="img/leaf_g.svg" alt=""><span>{{ formatCarbon(item.CarbonAmount) }} kg CO₂e</span></p>
                <p>商品價格：<span>{{ item.Price }}</span>元</p>
                <p>兌換期限：<span>{{ deadline }}</span></p>
                <p>剩餘數量：<span>{{ item.Inventory }}</span>份</p>
              </div>
              <div class="btn_box">
                <div class="num_box">
                  <p>商品數量</p>
                  <div class="num">
                    <button class="num_btn" type="button" @click="decrease">－</button>
                    <div class="quantity_num">{{ quantity }}</div>
                    <button class="num_btn" type="button" @click="increase">＋</button>
                  </div>
                </div>
                <button class="redeemNow_btn" type="button" :disabled="item.MaxQuantity <= 0" @click="openConfirm">立即兌換</button>

                <div class="redeemNow_modal modal fade" ref="redeemModal" tabindex="-1">
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="box">
                        <h2>您是否確認兌換此商品？</h2>
                        <div class="img_box"><div class="tag">限量兌換</div><img :src="itemImage" :alt="item.Name + '圖片'"></div>
                        <div class="text_box">
                          <p>商品名稱：<span>{{ item.Name }} × {{ quantity }}</span></p>
                          <p>本次扣除減碳量：<img src="img/leaf_g.svg" alt=""><span>{{ formatCarbon(totalCarbon) }} kg CO₂e</span></p>
                          <p>兌換後剩餘減碳量：<img src="img/leaf_g.svg" alt=""><span>{{ formatCarbon(carbonRemaining) }} kg CO₂e</span></p>
                        </div>
                      </div>
                      <div class="close_confirm">
                        <button type="button" class="close_btn" @click="closeConfirm">取消兌換</button>
                        <button type="button" class="confirm_btn" :disabled="submitting" @click="confirmRedeem">{{ submitting ? '處理中' : '確認兌換' }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="information_box">
            <div class="title"><p>商品資訊</p></div>
            <div class="text"><div v-html="item.Description"></div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
/* global $, moment */
import Storage from '@/utils/storage.js'

export default {
  name: 'CREventCouponMain',
  data () {
    return { loading: true, submitting: false, item: null, siteUrl: '', quantity: 1 }
  },
  computed: {
    itemImage () { return this.item && this.item.Image ? this.siteUrl + this.item.Image : 'img/coupon_logo.svg' },
    totalCarbon () { return this.item ? Number(this.item.CarbonAmount) * this.quantity : 0 },
    carbonRemaining () { return this.item ? Math.max(0, Number(this.item.CarbonValueAvailable) - this.totalCarbon) : 0 },
    deadline () {
      if (!this.item) return ''
      if (this.item.RedeemDateDescription) return this.item.RedeemDateDescription
      if (this.item.CouponEndTime) return moment(this.item.CouponEndTime).format('YYYY/MM/DD HH:mm') + ' 前'
      if (this.item.CouponLimitDay > 0) return '領取後 ' + this.item.CouponLimitDay + ' 天內'
      return '無使用期限'
    }
  },
  mounted () {
    $('.wrapper').addClass('crevent-coupon-main')
    $(window).scrollTop(0)
    this.loadItem()
  },
  beforeDestroy () {
    if (this.$refs.redeemModal) $(this.$refs.redeemModal).modal('hide')
  },
  methods: {
    loadItem () {
      const that = this
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + '/Htmlv2/CREventCouponItem',
        type: 'post',
        dataType: 'json',
        data: { token: Storage.get('ek_login_token'), CREId: that.$route.params.CREId, CRIId: that.$route.params.CRIId },
        complete: function () { that.loading = false },
        success: function (res) {
          if (!res.ok) return that.handleError(res)
          that.item = res.data
          that.siteUrl = res.SiteUrl
          that.quantity = that.item.MaxQuantity > 0 ? 1 : 0
        },
        error: function () { that.showError('取得商品資料失敗，請稍後再試一次') }
      })
    },
    increase () { if (this.quantity < this.item.MaxQuantity) this.quantity++ },
    decrease () { if (this.quantity > 1) this.quantity-- },
    openConfirm () {
      if (!this.item || this.item.MaxQuantity <= 0 || this.quantity < 1) return
      $(this.$refs.redeemModal).modal({ backdrop: 'static', keyboard: false, show: true })
    },
    closeConfirm () { if (!this.submitting) $(this.$refs.redeemModal).modal('hide') },
    confirmRedeem () {
      if (this.submitting) return
      const that = this
      that.submitting = true
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + '/Htmlv2/CREventRedeem',
        type: 'post',
        dataType: 'json',
        data: { token: Storage.get('ek_login_token'), CREId: that.$route.params.CREId, CRIId: that.$route.params.CRIId, quantity: that.quantity },
        complete: function () { that.submitting = false },
        success: function (res) {
          if (!res.ok) return that.handleError(res)
          $(that.$refs.redeemModal).modal('hide')
          that.$swal({ heightAuto: false, title: '兌換成功', text: '商品已加入優惠專區', icon: 'success', confirmButtonText: '確定' }).then(function () {
            that.$router.push({ name: 'CREventCoupon' })
          })
        },
        error: function () { that.showError('兌換失敗，請稍後再試一次') }
      })
    },
    formatCarbon (value) { return Number(value || 0).toFixed(1) },
    handleError (res) {
      if (res && res.toekn_error) {
        Storage.remove('ek_login_token')
        this.$router.push({ name: 'Login' })
        return
      }
      this.showError((res && res.error) || '操作失敗')
    },
    showError (message) { this.$swal({ heightAuto: false, title: '錯誤', text: message, icon: 'error', confirmButtonText: '確定' }) }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CREventCouponMain.vue